import angular from 'angular';
import reportEditConfig from './report-edit.config';

import reportEdit from '../../containers/report-edit';

const reportEditModule = angular.module('meredicte.reportEdit', [])
  .component('reportEdit', reportEdit)
  .config(reportEditConfig);

export default reportEditModule;



// WEBPACK FOOTER //
// ./src/modules/report-edit/report-edit.module.js